import React from 'react'

const ItemSelectableSimple = ({ children, onClick }) => {
    return (
        <div
            className='shadow-sm pt-3 ps-3 pe-3 pb-3 rounded-3 d-flex align-items-center justify-content-between'
            style={{ background: '#FFFF' }}
            type='button'
            onClick={onClick}
        >
            {children}
            <i
                style={{ color: '#98A0B6' }}
                className="fa-solid fa-chevron-right d-block"
            >
            </i>
        </div>
    )
}

export default ItemSelectableSimple